import { gql } from "@apollo/client";

export default gql`
  mutation setJobReminder($data: EmployerInput!) {
    setJobReminder(data: $data) {
      id
    }
  }
`;
